import React from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { I18nProvider, SUPPORTED_LOCALES } from "@/contexts/I18nContext";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import {
  PrivacyPolicy,
  CookiePolicy,
  TermsConditions,
} from "@/pages/LegalPages";
import ThankYou from "@/pages/ThankYou";

function LangGuard({ children }) {
  const { pathname } = useLocation();
  const seg = pathname.split("/").filter(Boolean)[0];
  if (!SUPPORTED_LOCALES.includes(seg)) {
    return <Navigate to="/fr" replace />;
  }
  return children;
}

function LocalizedLayout() {
  return (
    <I18nProvider>
      <div className="flex min-h-screen flex-col bg-[#F8FAFC]">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route index element={<Home />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="cookies" element={<CookiePolicy />} />
            <Route path="terms" element={<TermsConditions />} />
            <Route path="*" element={<Navigate to="" replace />} />
          </Routes>
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/fr" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route path="/:lang/*" element={<LangGuard><LocalizedLayout /></LangGuard>} />
          <Route path="*" element={<Navigate to="/fr" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
